/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { faker } from '@faker-js/faker/locale/en';
import { ENTITY_TYPES } from '../../constants/Repository.constants';
import { LEGACY_RUNTIME_IMAGE } from '../../constants/RuntimeImage.constants';
import { JobManifestDto, JobManifestRecord } from '../JobManifestTypes';

export const createMockJobManifestDto = (partialRecord: Partial<JobManifestRecord> = {}): JobManifestDto => {
  const tenant = faker.string.uuid();
  const name = faker.lorem.word();
  const version = Array.from({ length: 3 })
    .map(() => faker.number.int())
    .join('.');
  const input = {};

  return {
    concurrency: {
      N: (partialRecord.concurrency ?? faker.number.int()).toString(),
    },
    entryFile: { S: partialRecord.entryFile ?? faker.system.fileName() },
    entryFunction: {
      S: JSON.stringify(partialRecord.entryFunction) ?? JSON.stringify(input),
    },
    pk: {
      S: partialRecord.pk ?? `${ENTITY_TYPES.manifest}~${tenant}`,
    },
    sk: {
      S: partialRecord.sk ?? `${name}-${version}`,
    },
    name: {
      S: partialRecord.name ?? name,
    },
    version: {
      S: partialRecord.version ?? version,
    },
    timeoutSeconds: {
      N: (partialRecord.timeoutSeconds ?? faker.number.int({ max: 28800, min: 5 })).toString(),
    },
    image: {
      S: partialRecord.image ?? LEGACY_RUNTIME_IMAGE,
    },
    autoRetry: {
      BOOL: partialRecord.autoRetry ?? false,
    },
  };
};

export const createMockJobManifestDtos = (size?: number): Array<JobManifestDto> => {
  const randomSize = size ?? faker.number.int({ max: 3, min: 1 });
  return Array.from({ length: randomSize }).map(() => createMockJobManifestDto());
};
